import { Suspense } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteSubmissionListPage } from '@/features/instituteSubmissions/pages/InstituteSubmissionListPage';
import { instituteSubmissionSearchSchema } from '@/features/instituteSubmissions/types/instituteSubmission.types';

export const Route = createFileRoute('/_auth/settings/institute-submissions/')({
  validateSearch: instituteSubmissionSearchSchema,
  beforeLoad: ({ search }) => {
    if (search.submission === undefined) return;
    throw redirect({
      to: '/settings/institute-submissions/$submissionId',
      params: { submissionId: search.submission },
      replace: true,
    });
  },
  component: () => (
    <ErrorBoundary moduleName="Institute Submissions">
      <Suspense fallback={<PageLoader />}>
        <InstituteSubmissionListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
